import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
}), 'CompareArrowsTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CompareArrowsTwoTone.js
// module id = 2903
// module chunks = 2